import validate from '../vendor/validate';

class ValidateForm {
	constructor(formID, onSubmit = () => {}) {
		this.formID = formID;
		this.formEl = document.querySelector(`#${formID}`);
		this.submitButton = this.formEl.querySelector('[type="submit"]');
		this.onSubmit = onSubmit;

		this.formEl.setAttribute('novalidate', 'true');
		this.initValidate();
		this.addListeners();
	}

	addListeners() {
		this.formEl.addEventListener('submit', this.handleFormSubmit.bind(this), true);
	}

	initValidate() {
		const inputEls = this.formEl.querySelectorAll('input[required]:not([type="radio"]):not([type="checkbox"])');
		for (const inputEl of inputEls) {
			inputEl.addEventListener('blur', validate.inputHandler);
			inputEl.addEventListener('input', validate.inputHandler);
			inputEl.addEventListener('change', validate.inputHandler);
		}

		const checkboxEls = this.formEl.querySelectorAll('input[required][type="checkbox"], [type="checkbox-group"][aria-required="true"] input[type="checkbox"]');
		for (const checkboxEl of checkboxEls) {
			checkboxEl.addEventListener('change', validate.inputHandler);
		}

		const radioEls = this.formEl.querySelectorAll('input[required][type="radio"]');
		for (const radioEl of radioEls) {
			radioEl.addEventListener('change', validate.inputHandler);
		}
	}

	reInitRadioValidate(groupEl) {
		const radioEls = groupEl.querySelectorAll('input[required][type="radio"]');
		for (const radioEl of radioEls) {
			radioEl.addEventListener('change', validate.inputHandler);
		}
	}

	removeErrorMsg(elem) {
		if (elem.classList.contains('error')) {
			elem.classList.remove('error');
			const errorEl = elem.querySelector('.error-message');
			elem.removeChild(errorEl);
		}
	}

	addValidate(sectionEl) {
		const inputEls = sectionEl.querySelectorAll('input[aria-required="false"]:not([type="radio"]):not([type="checkbox"])');
		for (const inputEl of inputEls) {
			inputEl.required = true;
			inputEl.setAttribute('aria-required', 'true');

			inputEl.addEventListener('blur', validate.inputHandler);
			inputEl.addEventListener('input', validate.inputHandler);
			inputEl.addEventListener('change', validate.inputHandler);
		}

		const checkboxEls = sectionEl.querySelectorAll('input[aria-required="false"][type="checkbox"]');
		for (const checkboxEl of checkboxEls) {
			checkboxEl.required = true;
			checkboxEl.setAttribute('aria-required', 'true');

			checkboxEl.addEventListener('change', validate.inputHandler);
		}

		const radioEls = sectionEl.querySelectorAll('input[aria-required="false"][type="radio"]');
		for (const radioEl of radioEls) {
			radioEl.required = true;
			radioEl.setAttribute('aria-required', 'true');

			radioEl.addEventListener('change', validate.inputHandler);
		}
	}

	removeValidate(sectionEl) {
		const inputEls = sectionEl.querySelectorAll('input[required]:not([type="radio"]):not([type="checkbox"])');
		for (const inputEl of inputEls) {
			inputEl.removeEventListener('blur', validate.inputHandler);
			inputEl.removeEventListener('input', validate.inputHandler);
			inputEl.removeEventListener('change', validate.inputHandler);

			inputEl.required = false;
			inputEl.setAttribute('aria-required', 'false');
			this.removeErrorMsg(inputEl.closest('.form-group'));
		}

		const checkboxEls = sectionEl.querySelectorAll('input[required][type="checkbox"], [type="checkbox-group"][aria-required="true"] input[type="checkbox"]');
		for (const checkboxEl of checkboxEls) {
			checkboxEl.removeEventListener('change', validate.inputHandler);

			checkboxEl.required = false;
			checkboxEl.setAttribute('aria-required', 'false');
			if (checkboxEl.checked) {
				checkboxEl.checked = false;
				this.removeErrorMsg(checkboxEl.closest('.form-group'));
			}
		}

		const radioEls = sectionEl.querySelectorAll('input[required][type="radio"]');
		for (const radioEl of radioEls) {
			radioEl.removeEventListener('change', validate.inputHandler);

			radioEl.required = false;
			radioEl.setAttribute('aria-required', 'false');
			if (radioEl.checked) {
				radioEl.checked = false;
				this.removeErrorMsg(radioEl.closest('.form-group'));
			}
		}
	}

	validateForm(containerEl) {
		const queryEl = containerEl ? containerEl : this.formEl;
		const requiredFields = queryEl.querySelectorAll('[required], [type="checkbox-group"][aria-required="true"]');

		let hasErrors;
		let formErrors = false;

		for (const reqField of requiredFields) {
			const error = validate.hasError(reqField);

			if (!error) {
				validate.removeError(reqField);
				// eslint-disable-next-line no-continue
				continue;
			}

			validate.showError(reqField, error);
			if (!hasErrors) hasErrors = reqField;
		}

		if (hasErrors) {
			hasErrors.focus();
			formErrors = true;
		}

		return !formErrors;
	}

	handleFormSubmit(event) {
		event.preventDefault();

		// const iconElement = document.createElement('i');
		// iconElement.classList.add('icon', 'icon-loading-grey');
		this.oldSubmitButtonText = this.submitButton.innerText;
		this.submitButton.disabled = true;
		this.submitButton.querySelector('.button-text').innerText = 'Submitting';
		// this.submitButton.prepend(iconElement);

		const formValid = this.validateForm();

		if (!formValid) {
			event.preventDefault();
			this.submitButton.disabled = false;
			this.submitButton.querySelector('.button-text').innerText = this.oldSubmitButtonText;
			return false;
		}

		this.handleRecaptcha(event, (isRecaptchaCallback) => {
			if (!isRecaptchaCallback) return;

			// submit the form
			const isAjaxForm = this.formEl.dataset.ajaxSubmitUrl ? true : false;
			if (isAjaxForm) {
				this.submitAjaxForm(event);
			} else {
				this.formEl.submit();
			}

			this.onSubmit && this.onSubmit();
		});
		return true;
	}

	submitAjaxForm(event) {
		const endpoint = this.formEl.dataset.ajaxSubmitUrl;
		if (! endpoint) return false;

		event.preventDefault();
		const formData = new FormData(this.formEl);

		fetch(endpoint, {
			method: 'POST',
			body: formData,
		})
		.then(async (response) => {
			if (!response.ok) {
				throw new Error(`HTTP error status: ${response.status}`);
			}

			const json = await response.json();
			if (!json?.success) {
				throw new Error(`AJAX response returned errors: ${JSON.stringify(json?.errors || {})}`);
			}

			// show success page
			window.location.href = this.formEl.dataset.successRedirectUrl || '/';
		})
		.catch((error) => {
			console.error('Form submission error:', error);

			// reset form
			this.submitButton.disabled = false;
			this.submitButton.querySelector('.button-text').innerText = this.oldSubmitButtonText;
			this.resetCaptchaToken();

			alert('Something went wrong while submitting the form. Please try again later.');
		});
	}

	handleRecaptcha(event, onSubmit) {
		// skip recaptcha if the external script has not loaded - submission will be blocked back-end
		const siteKey = document.body.dataset.recaptchaSiteKey;
		const actionKey = document.body.dataset.recaptchaActionKey;
		const isReady = document.body.dataset.recaptchaIsReady === 'true';
		if (!(isReady && siteKey && actionKey)) {
			onSubmit(false);
			return;
		}

		// continue to submit if captcha has not been added to the form
		const captchaActionEl = this.formEl.querySelector(`[name="${actionKey}"]`);
		if (!captchaActionEl) {
			onSubmit(false);
			return;
		}

		// check for existing token
		const captchaTokenEl = captchaActionEl.nextElementSibling;
		if (!captchaTokenEl || captchaTokenEl.value) {
			onSubmit(false);
			return;
		}

		// fetch captcha token
		event.preventDefault();
		grecaptcha.execute(siteKey, { action: captchaActionEl.value }).then((token) => {
				captchaTokenEl.value = token;

				// token fetched - submit the form
				onSubmit(true);
			})
			.catch((error) => {
				console.error('reCAPTCHA error:', error);
				onSubmit(false);
			});
	}

	resetCaptchaToken() {
		const actionKey = document.body.dataset.recaptchaActionKey;
		if (!actionKey) return;

		const captchaTokenEl = this.formEl.querySelector(`[name="${actionKey}"]`)?.nextElementSibling;
		if (captchaTokenEl) captchaTokenEl.value = '';
	}
}

const newsletterFormEl = document.querySelector('#newsletterForm');
if (newsletterFormEl) {
	const formID = newsletterFormEl.getAttribute('id');
	new ValidateForm(formID);
}


const getInTouchFormEls = document.querySelectorAll('form.js-contact-form');
for (const getInTouchFormEl of getInTouchFormEls) {
	if (getInTouchFormEl) {
		const formID = getInTouchFormEl.getAttribute('id');
		new ValidateForm(formID);
	}
}